import { TApiSet } from "../../api/endpoints/Set";
import { ThunkDispatch } from "redux-thunk";
import { TRootState } from "../reducers/RootReducer";
import { Action } from "redux";
import * as Api from '../../api';
import ErrorHelpers from "../../utils/ErrorHelpers";

export const SETS_FETCH_STARTED = 'SETS_FETCH_STARTED';
export const SETS_FETCH_COMPLETED = 'SETS_FETCH_COMPLETED';
export const SETS_FETCH_FAILED = 'SETS_FETCH_FAILED';

export interface IFetchSetsStartedAction extends Action<typeof SETS_FETCH_STARTED> {
}

const fetchSetsStarted = (): IFetchSetsStartedAction => ({
  type: SETS_FETCH_STARTED
});

export interface IFetchSetsCompletedAction extends Action<typeof SETS_FETCH_COMPLETED> {
  data: Array<TApiSet>;
}

const fetchSetsCompleted = (sets: Array<TApiSet>): IFetchSetsCompletedAction => ({
  type: SETS_FETCH_COMPLETED,
  data: sets
});

export interface IFetchSetsFailedAction extends Action<typeof SETS_FETCH_FAILED> {
  error: Error;
}

const fetchSetsFailed = (error: Error): IFetchSetsFailedAction => ({
  type: SETS_FETCH_FAILED,
  error
});

const fetchSets = () => {
  return async (dispatch: ThunkDispatch<TRootState, void, Action>): Promise<Array<TApiSet>> => {
    try {
      dispatch(fetchSetsStarted());

      const sets = await Api.Set.list();

      dispatch(fetchSetsCompleted(sets));

      return sets;
    } catch (error) {
      if (ErrorHelpers.isError(error)) {
        dispatch(fetchSetsFailed(error));
      }

      throw error;
    }
  }
}

export {
  fetchSets
}
